module.exports = __webpack_public_path__ + "static/img/victim-kids-2.8c3adc33.png";